module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAoCAMAAADNGvrUAAAAaVBMVEUAAAD////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////8G612AAAAInRSTlMA8+r63BQQ4tXOt42Ea2BWTEM7MyslHxkE+PfGvqx1XQwIs1LRiQAAAJ5JREFUKM+N00cWwyAMRdG4d2NcY6f//S8yZPzwIQzvAJD0dTk7WfvycSM1Hu4kteTrw/nT47Xzjv65O+/p75uUGHpeOR/oWSntlr6lUjTS18L5RF9iKZ7p888X+hRJxUofnacb3R5SmdGHRKpyunGeeryXVP/LRrjk9Em744Moh8WzVaHGcgwcGkd82EAgEJ9A2BBNBpmxDy4JVyp8vlQrEfShCszkAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/components/img/bannerR.png
// module id = /rtr
// module chunks = 1